export default __webpack_public_path__ + "static/media/AgencyLandingPage.f4d08bad.jpeg";